let showFeatureDisabledModalRef = null;

export const setFeatureDisabledModalRef = (ref) => {
  showFeatureDisabledModalRef = ref;
};

export const triggerFeatureDisabledModal = () => {
  if (showFeatureDisabledModalRef) {
    showFeatureDisabledModalRef();
  }
};